import { AppIcons } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';

import { CareerPath } from './careerPath';
import { CareerTrack } from './careerTrack';
import { College } from './college';
import { ExternalProfile } from './externalProfile';
import { Internship } from './internship';
import { ContentNugget } from './nugget';
import { Scholarship } from './scholarship';
import { BackrsUser } from './user';

export const EDUCATIONAL_INVESTMENT_CODES_OBJECT = {
  HIGH_SCHOOL_ONLY: 'high_school_only',
  TRADE_TECHNICAL_SCHOOL: 'trade_technical_school',
  COMMUNITY_COLLEGE: 'community_college',
  LESS_SELECTIVE_4_YEAR: 'less_selective_4_year',
  SELECTIVE_4_YEAR: 'selective_4_year',
  VERY_SELECTIVE_4_YEAR: 'very_selective_4_year',
  GRADUATE_PROFESSIONAL_SCHOOL: 'graduate_professional_school',
  ENTREPRENEURSHIP: 'entrepreneurship',
  EARLY_CAREER_APPRENTICESHIP: 'early_career_apprenticeship',
  STRONG_MAJOR_FOCUS: 'strong_major_focus',
} as const;

export const EDUCATIONAL_INVESTMENT_CODES = Object.values(EDUCATIONAL_INVESTMENT_CODES_OBJECT);

export type EducationalInvestmentCode =
  (typeof EDUCATIONAL_INVESTMENT_CODES_OBJECT)[keyof typeof EDUCATIONAL_INVESTMENT_CODES_OBJECT];

export type EducationalInvestment = Readonly<{
  id: number;
  code: EducationalInvestmentCode;
  name: string;
  description: string;
  media_url?: string;
  toSucceed?: string[];
  icon?: AppIcons;
  hasBookmarked?: boolean;
  careerTracks?: CareerTrack[];
  contentNuggets?: ContentNugget[];
  scholarships?: Scholarship[];
  careerPaths?: CareerPath[];
  users?: BackrsUser[];
  externalProfiles?: ExternalProfile[];
  internships?: Internship[];
  institutions?: College[];
}>;
